// جستجوی محلی توی فهرستِ تگ‌ها — خوراکِ گزینه‌گرِ تگِ هر دو اپ.
//
// فهرستِ تگ‌ها کوچیکه (~۵۵ ردیف) و از قبل توی صفحه‌ست، پس برخلافِ شهرها
// جستجو هیچ رفت‌وبرگشتی نداره: همین‌جا فیلتر می‌شه. روی **همه‌ی** برچسب‌ها
// (هر زبانی که تگ داره) و slug می‌گرده، مستقل از زبانِ فعلی — کسی که اپش
// فارسیه ولی «rock» تایپ می‌کنه هم باید تگِ 🎸 راک رو پیدا کنه، و کسی که
// اپش آلمانیه هم با «Eishockey» هم با «hockey» باید به همون تگ برسه.
//
// دو ستونِ قدیمی هم عمداً موندن: تگِ حالتِ دمو `labels` نداره (WHOSUP-212).
import type { Tag } from '../domain/types.ts';

const tagMatches = (tag: Tag, needle: string): boolean =>
  Object.values(tag.labels ?? {}).some((l) => l.toLowerCase().includes(needle))
  || tag.labelFa.toLowerCase().includes(needle)
  || tag.labelEn.toLowerCase().includes(needle)
  || tag.slug.toLowerCase().includes(needle)
  || tag.emoji.includes(needle);

export function filterTags(tags: Tag[], q: string): Tag[] {
  const needle = q.trim().toLowerCase();
  if (!needle) return tags;
  return tags.filter((tag) => tagMatches(tag, needle));
}

// پیشنهادِ تگ برای فرمِ گروه (WHOSUP-151): برخلافِ گزینه‌گرِ بالا که با متنِ
// خالی همه رو نشون می‌ده، این‌جا شروعش هیچه — تا وقتی یکی از کلمه‌های
// تایپ‌شده به ۳ حرف نرسه هیچ تگی نشون داده نمی‌شه.
//
// تطبیق **هر جای برچسبه** — همون LIKE '%q%'. خواسته‌ی صریحِ ریویو: «ball»
// باید Basketball رو بیاره. یک نسخه‌ی «فقط اولِ کلمه» امتحان شد و رد شد،
// چون دقیقاً همین جور موردها رو گم می‌کرد؛ عوارضش (مثلاً «uni» که Community
// رو میاره) پذیرفته شده — دوباره سراغِ startsWith نرو.
export const TAG_SUGGEST_MIN = 3;

const suggestWords = (typed: string): string[] =>
  typed.trim().toLowerCase().split(/\s+/).filter((w) => w.length >= TAG_SUGGEST_MIN);

/** آیا اصلاً کلمه‌ای به حدِ نصاب رسیده؟ (برای این‌که UI بدونه راهنما نشون بده یا سکوت) */
export const hasTagSuggestQuery = (typed: string): boolean =>
  suggestWords(typed).length > 0;

export function suggestTags(tags: Tag[], typed: string): Tag[] {
  const words = suggestWords(typed);
  if (words.length === 0) return [];
  return tags.filter((tag) => words.some((w) => tagMatches(tag, w)));
}
